import { useEffect, useState } from "react";
import {
  getMe,
  togglePipelineNotifications,
} from "../../services/watchlist.service";
import { useAuthFetch } from "../../services/clerk.service";

const PipelineNotifications = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const authFetch = useAuthFetch();

  useEffect(() => {
    const load = async () => {
      try {
        const user = await getMe(authFetch);
        if (user.pipeline_notifications === undefined) {
          console.warn(
            "User object is missing pipeline_notifications field, defaulting to false",
          );
        }
        setEnabled(user.pipeline_notifications);
      } catch (err) {
        console.error("Failed to load user:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [authFetch]);

  const handleToggle = async () => {
    const next = !enabled;
    setSaving(true);
    try {
      await togglePipelineNotifications(authFetch, next);
      setEnabled(next);
    } catch (err) {
      console.error("Failed to toggle notifications:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="pn-card">
      <div className="pn-left">
        <div className="pn-icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.41 1.41M11.54 11.54l1.41 1.41M3.05 12.95l1.41-1.41M11.54 4.46l1.41-1.41"
              stroke="#34d399"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
            <circle cx="8" cy="8" r="2.5" stroke="#34d399" strokeWidth="1.4" />
          </svg>
        </div>
        <div>
          <p className="pn-title">Daily stock list email</p>
          <p className="pn-desc">
            Receive an email each evening after our pipeline finishes — showing
            today's top-rated stocks and fresh ratings.
          </p>
        </div>
      </div>

      <button
        className={`pn-toggle${enabled ? " pn-toggle-on" : ""}`}
        onClick={handleToggle}
        disabled={loading || saving}
        aria-pressed={enabled}
      >
        <span className="pn-toggle-knob" />
      </button>
    </div>
  );
};

export default PipelineNotifications;
